import React from 'react';
import styles from './InventoryDiscrepancies.module.scss';
import FilterInTable from '../../../../../Manage/FilterInTable';
import DatatableComponent from '../../../../../../components/common/DatatableComponent/DatatableComponent';

const data = [
    {
        id: 1,
        discId: 'DISC-001',
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantityExpected: 200,
        quantityReceived: 190,
        discNotes: '10 units missing',
    },
    {
        id: 2,
        discId: 'DISC-001',
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantityExpected: 200,
        quantityReceived: 190,
        discNotes: '10 units missing',
    },
    {
        id: 3,
        discId: 'DISC-001',
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantityExpected: 200,
        quantityReceived: 190,
        discNotes: '10 units missing',
    },
    {
        id: 4,
        discId: 'DISC-001',
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantityExpected: 200,
        quantityReceived: 190,
        discNotes: '10 units missing',
    },
    {
        id: 5,
        discId: 'DISC-001',
        shipmentId: 'SHIP-001',
        productId: '3475943',
        productName: 'Blue colored headphones',
        skuId: 'SKU-001',
        quantityExpected: 200,
        quantityReceived: 190,
        discNotes: '10 units missing',
    },
];

const columns = [
    {
        name: 'Discrepancy ID',
        selector: (row) => row.discId,
        sortable: true,
        minWidth: "180px",
    },
    {
        name: 'Shipment ID',
        selector: (row) => row.shipmentId,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: 'Product ID',
        selector: (row) => row.productId,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: 'Product Name',
        selector: (row) => row.productName,
        sortable: true,
        maxWidth: '250px',
        minWidth: "220px",
    },
    {
        name: 'SKU ID',
        selector: (row) => row.skuId,
        sortable: true,
        minWidth: "120px",
    },
    {
        name: 'Quantity Expected',
        selector: (row) => row.quantityExpected,
        sortable: true,
        minWidth: "200px",
    },
    {
        name: 'Quantity Received',
        selector: (row) => row.quantityReceived,
        sortable: true,
        minWidth: "200px",
    },
    {
        name: 'Discrepancy Notes',
        selector: (row) => row.discNotes,
        sortable: true,
        minWidth: "200px",
    },
];

const InventoryDiscrepancies = () => {

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Inventory Discrepancies</h4>

            <div className={styles.inventoryDiscrepanciesContainer}>

                <FilterInTable componentName={"Inventory Discrepancies"} />

                <div className={styles.inventoryTable}>
                    <DatatableComponent
                        columns={columns}
                        data={data}
                        pagination
                        highlightOnHover
                        type="yellow"
                    />
                </div>
            </div>
        </div>
    )
}

export default InventoryDiscrepancies;